import { render, staticRenderFns } from "./BreadCrumb.vue?vue&type=template&id=1534cc1c&scoped=true&"
import script from "./BreadCrumb.vue?vue&type=script&lang=js&"
export * from "./BreadCrumb.vue?vue&type=script&lang=js&"
import style0 from "./BreadCrumb.vue?vue&type=style&index=0&id=1534cc1c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1534cc1c",
  null
  
)

export default component.exports